import { render, staticRenderFns } from "./tournamentsList-eventGroups.vue?vue&type=template&id=6a327e98&scoped=true&"
import script from "./tournamentsList-eventGroups.vue?vue&type=script&lang=js&"
export * from "./tournamentsList-eventGroups.vue?vue&type=script&lang=js&"
import style0 from "./tournamentsList-eventGroups.vue?vue&type=style&index=0&id=6a327e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a327e98",
  null
  
)

export default component.exports